import { useMutation } from "react-query";
import ObjectTagValuesDataService from "../../services/object-tag-values-data-service/ObjectTagValuesDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { useSaveObjectTagValuesConfiguration } from "./UseSaveObjectTagValuesConfiguration";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { AccessType } from "../../common/enums/DRCXEnums";

export type UseModifyObjectTagValuesConfigurationAccessResultType = {
    oldAccess: AccessType;
    newAccess: AccessType;
}

export type UseModifyObjectTagValuesConfigurationAccessParameters = {
    groupID: number,
    objectType: eLynxObjectTypeEnum,
    objectID: number,
    configurationID: number
} & BaseUseMutationParameters<UseModifyObjectTagValuesConfigurationAccessResultType, AccessType>;

export function useModifyObjectTagValuesConfigurationAccess({
    groupID,
    objectType,
    objectID,
    configurationID,
    onError,
    onSuccess
}: UseModifyObjectTagValuesConfigurationAccessParameters) {

    const { mutateAsync: saveConfiguration } = useSaveObjectTagValuesConfiguration({
        groupID,
        objectType,
        objectID
    });

    return useMutation<UseModifyObjectTagValuesConfigurationAccessResultType, RestError, AccessType>(
        async (access) => {

            const model = await ObjectTagValuesDataService.getConfiguration(
                groupID,
                configurationID
            );
            const oldAccess = model.access;
            model.access = access;

            await saveConfiguration(model);

            return {
                oldAccess,
                newAccess: access
            }
        },
        {
            onError: onError,
            onSuccess: onSuccess
        }
    );
}